module.exports = __webpack_public_path__ + "static/media/TP19.2c2c6a99.jpg";